import { render, staticRenderFns } from "./control3Synchronoustext.vue?vue&type=template&id=47ed2bce&scoped=true&"
import script from "./control3Synchronoustext.vue?vue&type=script&lang=js&"
export * from "./control3Synchronoustext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed2bce",
  null
  
)

export default component.exports